import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {OpenCloseMenuEventArgs, DropDownButtonComponent} from '@syncfusion/ej2-angular-splitbuttons';

@Component({
  selector: 'app-mise-en-avant',
  templateUrl: './mise-en-avant.component.html',
  styleUrls: ['./mise-en-avant.component.scss'],
})
export class MiseEnAvantComponent implements OnInit {
  private _dropDownButton: DropDownButtonComponent;
  constructor() {}

  @Input() titre: string;
  @Input() sousTitre: string;

  @Input() chips;
  @Input() actionMenuDisabled = true;
  private _menu: any[];
  @Input() set menu(value: any[]) {
    this._menu = value;
  }

  get menu() {
    return this._menu;
  }

  @Input() icon: TemplateRef<any>;

  @ViewChild('dropdownbtn') set drowdownbutton(value: any) {
    this._dropDownButton = value
  }

  public onOpen (args: OpenCloseMenuEventArgs) {
    args.element.parentElement.style.left = this._dropDownButton.element.getBoundingClientRect().left - args.element.parentElement.offsetWidth + 'px';
  }

  performAction(item) {
    if (item.action != null) {
      item.action.next();
    }
  }

  ngOnInit() {}

}
